import { globalTranslate } from '@pfsc/shared/locale/app.i18n';

export const USER_ACCOUNT_STATUS = {
  IN_ACTIVE: 'Inactive',
  ACTIVE: 'Active',
};

export const USER_ACCOUNT_STATUS_VALUE = {
  [USER_ACCOUNT_STATUS.ACTIVE]: 1,
  [USER_ACCOUNT_STATUS.IN_ACTIVE]: 0,
};

export const USER_ACCOUNT_STATUS_TO_READABLE = {
  [USER_ACCOUNT_STATUS.IN_ACTIVE]: globalTranslate('userStatus.inactive'),
  [USER_ACCOUNT_STATUS.ACTIVE]: globalTranslate('userStatus.active'),
};

/**
 * Map user status to readable text.
 * @param {string} status User account status.
 * @returns {string} Readable status.
 */
export class UserAccountStatus {
  constructor(dto) {
    this.name = dto.name;
    this.value = dto.value;
  }

  /**
   * Map to readable
   * @param {UserAccountStatus} status User account status.
   * @returns {string}
   */
  static toReadableUserAccountStatus(status) {
    const readableStatus = USER_ACCOUNT_STATUS_TO_READABLE[status];
    return readableStatus ?? status;
  }
}
